export interface IDataGraphLine {
  backgroundColor: CanvasGradient;
  label: string;
  data: number[];
}

export interface IDataGraph {
  labels: string[];
  data: IDataGraphLine[];
}

export const PRESET_GRAPH_DATA = {
  datasets: [
    {
      pointHoverBorderWidth: 4,
      pointHoverBorderColor: 'rgba(255, 45, 107, 0.5)',
      pointBackgroundColor: '#FF2D6B',
      borderWidth: 2,
      lineTension: 0,
      borderColor: '#FF2D6B',
      datalabels: {
        color: '#FF2D6B',
      },
    },
    {
      pointHoverBorderWidth: 4,
      pointHoverBorderColor: 'rgba(4, 104, 255, 0.5)',
      pointBackgroundColor: '#0468FF',
      borderWidth: 2,
      lineTension: 0,
      borderColor: '#0468FF',
      datalabels: {
        color: '#0468FF',
      },
    },
  ],
};

/**
 * Подготовка данных для отрисовки графика
 *
 * @param data данные для графиков
 */
export function preparedData(data: IDataGraph) {
  const {
    labels,
    data: [oneGraph, twoGraph],
  } = data;

  return {
    ...PRESET_GRAPH_DATA,
    labels,
    datasets: [
      {
        ...PRESET_GRAPH_DATA.datasets[0],
        ...oneGraph,
      },
      {
        ...PRESET_GRAPH_DATA.datasets[1],
        ...twoGraph,
      },
    ],
  };
}
